export default __webpack_public_path__ + "static/media/radio-full-disabled.icon.e277cb9d.svg";